import { EstadosDesvinculacionValidation, opcionesSideBar, ROL_ADMINISTRADOR, ROL_ANALISTA_TH, ROL_APROBADOR, ROL_DIRECTIVO_UNIDAD, ROL_DIRECTOR_TALENTOHUMANO, TITULO_EMISION_CERTIFICADOS, useSideBarContext, ROL_ASESOR, ROL_GERENTE_FINANCIERO } from 'Context/SideBarContext';
import { VerificarSoloTieneContratoRegimen } from 'functions/DatosUsuarioFunctions';
import React from 'react'
import { useHistory } from 'react-router';
import { TransitionStatus } from 'react-transition-group';
import { authenticationService } from 'services/authentication.service';
import { Icono_Flecha_Regreso, UserData } from './Sidebar_Principal';
import Sidebar_Principal_Row from './Sidebar_Principal_Row';
import { expresion_adm } from 'components/Admin/Inicio-Admin/Dashboard_Admin';
export interface Sidebar_Principal_SubmenuProps {
    state_transition: TransitionStatus,
    datos_usuario: UserData
}

export const ID_REGIMEN_CONTRATO_CIVIL = 0;
export const ID_REGIMEN_CONTRATO_LOES = 0;

const Sidebar_Principal_Submenu = (props: Sidebar_Principal_SubmenuProps) => {
    const { subMenuNieto, valoressubMenu, subMenu, setsubMenu, titulo_opcion_padre, icono_opcion_padre, subMenuDatosPersonales } = useSideBarContext()
    const component_arrow_left_header = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
    </svg>

    let history = useHistory();

    const function_choice_animation_style = () => {
        const componente_salio = props.state_transition === "exited" || props.state_transition === "unmounted" || props.state_transition === "exiting"
        const timing = ".4s"

        if (props.state_transition === "entering" && subMenu) {
            return {
                animation: `moveSubContainer ${timing} forwards`
            }
        }

        else if (props.state_transition === "entered") {
            return {
                transform: "translateX(0px)"
            }
        }
        else if (componente_salio && !subMenuNieto && !subMenuDatosPersonales) {
            return {
                animation: `moveSubContainer ${timing} reverse forwards`
            }
        }
        else if (componente_salio && subMenuNieto) {
            return {
                animation: `moveMainContainer ${timing} forwards`
            }
        }
        else if (componente_salio && subMenuDatosPersonales) {
            return {
                animation: `moveMainContainer ${timing} forwards`
            }
        }
    }

    function handleClickOpcion(opciones: opcionesSideBar) {
        if (opciones.link) history.push(opciones.link);
    }

    function condicion_mostrar_opciones_submenu(opciones: opcionesSideBar, datosUsuario: UserData) {
        const titulo_opcion_condicional_solicitud_certificados = "Solicitud Certificado";
        const titulos_opcion_aprobadores = ["Aprobación  Vacaciones", "Historial Aprobación Vacaciones"]
        const titulo_Emision_Certificados = "Emisión Certificados";
        const titulo_tramites_frecuentes = "Trámites Frecuentes";
        const titulo_acuerdo_medios_electronicos = "Acuerdo de Medios Electrónicos";
        const titulo_registro_e_s_almuerzo = "Registro de receso/almuerzo";
        const titulo_registro_marcaciones = "Registro de marcaciones";
        const titulo_registro_marcaciones2 = "Registro de marcaciones ";
        const titulo_notificacion_embarazo = "Notificación de embarazo";
        const titulo_cambio_horario_RN = "Solicitud de cambio de horario de permiso para cuidado del recién nacido";
        const titulo_informacion_personal = "Información Personal";
        const titulo_nuevoth = "Nuevo Talento Humano";
        const titulo_asistencia = "Asistencia";
        const PERSONALDOCENTE = "PD";
        const PERSONALADMINISTRATIVO = "PA";
        var resultado: JSX.Element = (
            <div className="submenuOpcionesHeader  ">
                <div className="container_icono_Principal_Content">
                    {/* {props.icon_opcion_padre?props.icon_opcion_padre():""} */}
                </div>
                {
                    <div className=" texto_submenuOpcionesHeader" onClick={() => handleClickOpcion(opciones)}>
                        {opciones.tituloStyled}

                    </div>
                }
                {
                    opciones.tituloStyled === undefined &&
                    <div className=" texto_submenuOpcionesHeader" onClick={() => handleClickOpcion(opciones)}>
                        {opciones.titulo}

                    </div>
                }

            </div>
        )

        var resultadoRedirect: JSX.Element = (
            <div className="submenuOpcionesHeaderNieto  ">
                <div className="container_icono_Principal_Content">
                    {/* {props.icon_opcion_padre?props.icon_opcion_padre():""} */}
                </div>
                {
                    <span onClick={() => handleClickOpcion(opciones)}>
                        {opciones.tituloStyled}
                    </span>
                }
                {
                    opciones.tituloStyled === undefined &&
                    <a className=" texto_submenuOpcionesHeaderNieto" href={opciones.link} target="_blank">
                            {opciones.titulo}
                    </a>
                }
            </div>
        )

        if (opciones.titulo === titulo_informacion_personal) {
            return resultadoRedirect
        }
        else if (opciones.titulo === titulo_nuevoth) {
            return resultadoRedirect
        }
        else if (opciones.titulo === titulo_opcion_condicional_solicitud_certificados || opciones.titulo === titulo_tramites_frecuentes || opciones.titulo === titulo_acuerdo_medios_electronicos) {
            if (!datosUsuario.soloTieneContratoESPOLTECH) {
                return resultado
            }
        }
        else if (opciones.titulo === titulo_registro_e_s_almuerzo) {
            if (expresion_adm(datosUsuario.regimen_usuario) && !datosUsuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) && !datosUsuario.roles_usuario.includes(ROL_ASESOR))
                return resultado
        }
        else if (opciones.titulo === titulo_registro_marcaciones) {
            if (expresion_adm(datosUsuario.regimen_usuario) && datosUsuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD))
                return resultado
        }
        else if (opciones.titulo === titulo_registro_marcaciones2) {
            if (expresion_adm(datosUsuario.regimen_usuario) && datosUsuario.roles_usuario.includes(ROL_ASESOR))
                return resultado
        }
        else if (titulos_opcion_aprobadores.includes(opciones.titulo)) {
            if (datosUsuario.roles_usuario.includes(ROL_APROBADOR)) {
                return resultado
            }
        } else if (opciones.titulo === titulo_notificacion_embarazo) {
            if (datosUsuario.genero == "F") {
                return resultado
            }
        } else if (opciones.titulo === titulo_cambio_horario_RN) {
            if (datosUsuario.genero == "F") {
                return resultado
            }
        } 
        else {
            return resultado;
        }
    }

    function condicion_mostrar_Rows(opciones: opcionesSideBar, datosUsuario: UserData) {
        var opcionMenu = <Sidebar_Principal_Row titulo_opcion_padre={opciones.titulo} subopciones={opciones} isChild={true} />
        var cantidadRegimenPersona = datosUsuario.regimen_usuario.length;
        var TieneContratoCivil = datosUsuario.regimen_usuario.includes(0);
        const titulo_tramites_frecuentes = "Trámites Frecuentes";
        const titulo_vinculacion = "Vinculación ";

        if (opciones.rol_usuario && opciones.rol_usuario === ROL_ADMINISTRADOR) {
            var isAnalista = datosUsuario.roles_usuario.includes(ROL_ANALISTA_TH)
            var isAdministrador = datosUsuario.roles_usuario.includes(ROL_ADMINISTRADOR)
            var isDirectorTH = datosUsuario.roles_usuario.includes(ROL_DIRECTOR_TALENTOHUMANO)

            const OPCIONES_PARA_ANALISTAS = ["Certificados"]

            var isOpcionForAnalistas = OPCIONES_PARA_ANALISTAS.includes(opciones.titulo)

            if ((isAnalista || isDirectorTH) && isOpcionForAnalistas) {
                return opcionMenu
            }
            if (isAdministrador && !isOpcionForAnalistas) {
                return opcionMenu
            }
        }
        else if (opciones.titulo === "Vacaciones") {
            if (!datosUsuario.soloTieneContratoESPOLTECH && !VerificarSoloTieneContratoRegimen(ID_REGIMEN_CONTRATO_CIVIL, datosUsuario)) {
                return opcionMenu
            }
        }
        else if (opciones.titulo === "Permisos/Licencias") {
            if (!datosUsuario.soloTieneContratoESPOLTECH && !VerificarSoloTieneContratoRegimen(ID_REGIMEN_CONTRATO_CIVIL, datosUsuario)) {
                return opcionMenu
            }
        }
        else if (opciones.titulo === "Aprobaciones") {
            if (!datosUsuario.soloTieneContratoESPOLTECH && !VerificarSoloTieneContratoRegimen(ID_REGIMEN_CONTRATO_CIVIL, datosUsuario)) {
                return opcionMenu
            }
        }
        else if (opciones.titulo === titulo_tramites_frecuentes) {
            if (!datosUsuario.soloTieneContratoESPOLTECH) {
                return opcionMenu
            }
        }
        else if (opciones.titulo === "Asistencia") {
            if ((expresion_adm(datosUsuario.regimen_usuario) && !datosUsuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD) && !datosUsuario.roles_usuario.includes(ROL_ASESOR)) || (expresion_adm(datosUsuario.regimen_usuario) && datosUsuario.roles_usuario.includes(ROL_ASESOR)))
                return opcionMenu
        }
        else if (opciones.titulo === "Asistencia ") {
            if (expresion_adm(datosUsuario.regimen_usuario) && datosUsuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD))
                return opcionMenu
        } else if (opciones.titulo === titulo_vinculacion) {
            if (datosUsuario.roles_usuario.includes(ROL_GERENTE_FINANCIERO)) {
                return opcionMenu
            }
        }
        else if (opciones.titulo === "Solicitudes Administrativas"){
            if (!datosUsuario.soloTieneSolicitudContratacion) {
                return opcionMenu;
            }
        }
        else {
            return (opcionMenu);
        }
    }

    return (
        <div className={"sidenavPrincipalSubmenu"} style={function_choice_animation_style()}>
            <div className="submenuHeader" onClick={() => setsubMenu(false)}>

                <div>
                    {Icono_Flecha_Regreso}
                </div>
                <div className="container_icono_padre_submenu">
                    {icono_opcion_padre}
                </div>
                <div>
                    {titulo_opcion_padre}
                </div>
            </div>
            {valoressubMenu.map((opciones, index) => {
                return (
                    <React.Fragment key={index}>

                        {!opciones.tipo.rows ?
                            condicion_mostrar_opciones_submenu(opciones, props.datos_usuario)
                            :
                            condicion_mostrar_Rows(opciones, props.datos_usuario)
                        }
                        {/* {!opciones.tipo.rows ?
                            <div className="submenuOpcionesHeader  ">
                                <div className="container_icono_Principal_Content">
                                    {/* {props.icon_opcion_padre?props.icon_opcion_padre():""} }
                                </div>
                                <div className=" texto_submenuOpcionesHeader" onClick={() => handleClickOpcion(opciones)}>
                                    {opciones.titulo}

                                </div>
                            </div> :
                            <Sidebar_Principal_Row titulo_opcion_padre={opciones.titulo} subopciones={opciones} isChild={true} />
                        } */}
                    </React.Fragment>
                )
            })}
        </div>
    )
}
export default Sidebar_Principal_Submenu;